import { object, string } from 'zod';

import { intl } from '@ocx-app/lib/translation/TranslationProvider';
import { makeValidate } from '@ocx-app/lib/form/utils';

import { validatePhoneNumber } from '@ocx/utils-phone-number';

import { messages } from '../../signup.messages';

const phoneNumberErrorMessage = intl.formatMessage(messages['signUp:validation:phoneNumberValidation']);

export const schema = object({
  phoneNumber: string({ message: phoneNumberErrorMessage }).refine((value) => validatePhoneNumber(value), {
    message: phoneNumberErrorMessage,
  }),
  referralCode: string().nullable(),
});

export const validation = makeValidate(schema);
